"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const FudaoDefinition_1 = require("./FudaoDefinition");
const RtcCommand_1 = require("../Engine/Command/RtcCommand");
class FudaoCommand {
    static TeacherCreatedFudaoCommand(temp) {
        return RtcCommand_1.RtcCommand.Builder()
            .AutoId()
            .Category(FudaoCommand.Category)
            .Name(FudaoCommand.TeacherCreateFudao)
            .CmdTypeAction(RtcCommand_1.CmdType.RequestExecute)
            .IsToService(true)
            .Content(temp)
            .Build();
    }
    static TeacherCreatedFudaoResponseAcceptCommand(resObj) {
        return RtcCommand_1.RtcCommand.Builder()
            .AutoId()
            .Category(FudaoCommand.Category)
            .Name(FudaoCommand.TeacherCreateFudao)
            .CmdTypeAction(RtcCommand_1.CmdType.ResponseAccept)
            .IsToService(true)
            .Content(resObj)
            .Build();
    }
    static TeacherInviteStartFudaoCommand(fudaoDto, receiver, cmdType = RtcCommand_1.CmdType.RequestExecute) {
        return RtcCommand_1.RtcCommand.Builder()
            .AutoId()
            .Category(FudaoCommand.Category)
            .Name(FudaoCommand.TeacherInviteStartFudao)
            .CmdTypeAction(cmdType)
            .IsToService(false)
            .Receiver(receiver.Name)
            .TargetId(fudaoDto.id)
            .Content(fudaoDto)
            .Build();
    }
    static TeacherStartFudaoCommand(fudaoDto, cmdType = RtcCommand_1.CmdType.RequestExecute) {
        return RtcCommand_1.RtcCommand.Builder()
            .AutoId()
            .Category(FudaoCommand.Category)
            .Name(FudaoCommand.TeacherStartFudao)
            .CmdTypeAction(cmdType)
            .IsToService(true)
            .TargetId(fudaoDto.id)
            .Content(fudaoDto)
            .Build();
    }
    static TeacherReportFudaoIsAliveCommand(fudaoDto, cmdType = RtcCommand_1.CmdType.RequestExecute) {
        return RtcCommand_1.RtcCommand.Builder()
            .AutoId()
            .Category(FudaoCommand.Category)
            .Name(FudaoCommand.TeacherReportFudaoIsAlive)
            .CmdTypeAction(cmdType)
            .IsToService(true)
            .TargetId(fudaoDto.id)
            .Content(fudaoDto)
            .Build();
    }
    static TeacherInviteEndFudaoCommand(fudaoDto, receiver, cmdType = RtcCommand_1.CmdType.RequestExecute) {
        return RtcCommand_1.RtcCommand.Builder()
            .AutoId()
            .Category(FudaoCommand.Category)
            .Name(FudaoCommand.TeacherInviteEndFudao)
            .CmdTypeAction(cmdType)
            .IsToService(false)
            .Receiver(receiver.Name)
            .TargetId(fudaoDto.id)
            .Content(fudaoDto)
            .Build();
    }
    static TeacherEndFudaoCommand(fudaoDto, cmdType = RtcCommand_1.CmdType.RequestExecute) {
        return RtcCommand_1.RtcCommand.Builder()
            .AutoId()
            .Category(FudaoCommand.Category)
            .Name(FudaoCommand.TeacherEndFudao)
            .CmdTypeAction(cmdType)
            .IsToService(true)
            .TargetId(fudaoDto.id)
            .Content(fudaoDto)
            .Build();
    }
    static TeacherInviteExtendFudaoCommand(fudaoDto, receiver, cmdType = RtcCommand_1.CmdType.RequestExecute) {
        return RtcCommand_1.RtcCommand.Builder()
            .AutoId()
            .Category(FudaoCommand.Category)
            .Name(FudaoCommand.TeacherInviteExtendFudao)
            .CmdTypeAction(cmdType)
            .IsToService(false)
            .Receiver(receiver.Name)
            .TargetId(fudaoDto.id)
            .Content(fudaoDto)
            .Build();
    }
    static TeacherExtendFudaoCommand(fudaoDto, lastExtendTimes, cmdType = RtcCommand_1.CmdType.RequestExecute) {
        return RtcCommand_1.RtcCommand.Builder()
            .AutoId()
            .Category(FudaoCommand.Category)
            .Name(FudaoCommand.TeacherExtendFudao)
            .CmdTypeAction(cmdType)
            .IsToService(true)
            .TargetId(fudaoDto.id)
            .Content(lastExtendTimes)
            .Build();
    }
    static TeacherInviteStartSessionCommand(fudaoDto, fudaoSession, receiver, cmdType = RtcCommand_1.CmdType.RequestExecute) {
        return RtcCommand_1.RtcCommand.Builder()
            .AutoId()
            .Category(FudaoCommand.Category)
            .Name(FudaoCommand.TeacherInviteStartSession)
            .CmdTypeAction(cmdType)
            .IsToService(false)
            .Receiver(receiver.Name)
            .TargetId(fudaoDto.id)
            .Content(fudaoSession)
            .Build();
    }
    static TeacherInviteEndSessionCommand(fudaoDto, fudaoSession, receiver, cmdType = RtcCommand_1.CmdType.RequestExecute) {
        return RtcCommand_1.RtcCommand.Builder()
            .AutoId()
            .Category(FudaoCommand.Category)
            .Name(FudaoCommand.TeacherInviteEndSession)
            .CmdTypeAction(cmdType)
            .IsToService(false)
            .Receiver(receiver.Name)
            .TargetId(fudaoDto.id)
            .Content(fudaoSession)
            .Build();
    }
}
FudaoCommand.Category = FudaoDefinition_1.FudaoCommandCategory;
FudaoCommand.TeacherCreateFudao = "TeacherCreateFudao";
FudaoCommand.TeacherInviteStartFudao = "TeacherInviteStartFudao";
FudaoCommand.TeacherStartFudao = "TeacherStartFudao";
FudaoCommand.TeacherReportFudaoIsAlive = "TeacherReportFudaoIsAlive";
FudaoCommand.TeacherInviteEndFudao = "TeacherInviteEndFudao";
FudaoCommand.TeacherEndFudao = "TeacherEndFudao";
FudaoCommand.TeacherInviteExtendFudao = "TeacherInviteExtendFudao";
FudaoCommand.TeacherExtendFudao = "TeacherExtendFudao";
FudaoCommand.TeacherInviteStartSession = "TeacherInviteStartSession";
FudaoCommand.TeacherInviteEndSession = "TeacherInviteEndSession";
FudaoCommand.TeacherReportRatingToService = "TeacherReportRatingToService";
FudaoCommand.StudentReportRatingToService = "StudentReportRatingToService";
FudaoCommand.QueryFudaosByTeacher = "QueryFudaosByTeacher";
FudaoCommand.QueryFudaosByStudent = "QueryFudaosByStudent";
exports.FudaoCommand = FudaoCommand;
//# sourceMappingURL=FudaoCommand.js.map